import React, { FC, useCallback } from 'react';
import {
  Box,
  Button,
  List,
  ListItemIcon,
  ListItemText,
  Theme,
  Tooltip,
  Typography,
} from '@mui/material';
import { MdExpandMore as ExpandMoreIcon } from 'react-icons/md';
import { FaFileCsv } from 'react-icons/fa';
import { makeStyles } from 'tss-react/mui';
import OxMenuControlled from '../../../../elements/OxMenu/OxMenuControlled';
import { CiExport as ExportIcon } from 'react-icons/ci';
import { useIsScanning } from '../../../../new-scan/actions/scan-actions';
import ExtendedMenuItem from '../../../../elements/OxMenu/ExtendedMenuItem';
import SubMenuItem from '../../../../elements/OxMenu/SubMenuItem';
import { RiFilterFill, RiFilterOffFill } from 'react-icons/ri';
import { exportIssuesToCSVfile } from '../../../active-issues/actions/active-issues-actions';

const IssuesControlPanel: FC<
  React.PropsWithChildren<IssuesControlPanelProps>
> = ({
  openExportIssuesMenu,
  setOpenExportIssuesMenu,
  numberOfFilters,
  // searchValue,
}) => {
  const { classes } = useStyles();
  const isScanning = useIsScanning();

  const onExportIssuesMenuClick = useCallback(() => {
    setOpenExportIssuesMenu(true);
  }, [setOpenExportIssuesMenu]);

  const onExportIssuesMenuClose = useCallback(() => {
    setOpenExportIssuesMenu(false);
  }, [setOpenExportIssuesMenu]);

  const exportAllIssues = useCallback(() => {
    exportIssuesToCSVfile(false);
  }, []);

  const exportFilteredIssues = useCallback(() => {
    exportIssuesToCSVfile(true);
  }, []);

  return (
    <Box
      justifyContent='flex-end'
      display='flex'
      flexDirection='row'
      alignItems='center'>
      {/* <TextField
        size='small'
        value={searchValue}
        onChange={onSearchValueChange}
        id='search-apps'
        placeholder='Search'
        sx={{
          minWidth: 200,
          mx: 1,
        }}
        InputProps={{
          endAdornment: <Search />,
        }}
      /> */}
      <OxMenuControlled
        id='issues-download-menu'
        trigger={
          <Tooltip
            title={
              isScanning ? (
                <Typography variant='body2' color='text.primary'>
                  Option available when a scan finishes
                </Typography>
              ) : (
                ''
              )
            }>
            <span>
              <Button
                classes={{
                  startIcon: classes.startIcon,
                }}
                startIcon={<ExportIcon />}
                endIcon={<ExpandMoreIcon />}
                onClick={onExportIssuesMenuClick}
                sx={{ textTransform: 'none' }}>
                <Typography variant='caption' color='inherit'>
                  Export Issues
                </Typography>
              </Button>
            </span>
          </Tooltip>
        }
        open={openExportIssuesMenu}
        onClose={onExportIssuesMenuClose}>
        <ExtendedMenuItem
          id='export-issues-file-type'
          withIcon
          subMenu={
            <List>
              <SubMenuItem key='csv-type' onClick={exportAllIssues}>
                <ListItemIcon>
                  <FaFileCsv fontSize='large' />
                </ListItemIcon>
                <ListItemText>CSV</ListItemText>
              </SubMenuItem>
            </List>
          }>
          <ListItemIcon>
            <RiFilterOffFill fontSize='small' />
          </ListItemIcon>
          <ListItemText>All Issues</ListItemText>
        </ExtendedMenuItem>
        <ExtendedMenuItem
          disabled={!!!numberOfFilters}
          id='export-issues-file-type'
          withIcon
          subMenu={
            numberOfFilters ? (
              <List>
                <SubMenuItem
                  disabled={!!!numberOfFilters}
                  key='csv-type'
                  onClick={exportFilteredIssues}>
                  <ListItemIcon>
                    <FaFileCsv fontSize='large' />
                  </ListItemIcon>
                  <ListItemText>CSV</ListItemText>
                </SubMenuItem>
              </List>
            ) : (
              ''
            )
          }>
          <ListItemIcon>
            <RiFilterFill fontSize='small' />
          </ListItemIcon>
          <ListItemText>Filtered Issues</ListItemText>
        </ExtendedMenuItem>
      </OxMenuControlled>
    </Box>
  );
};

const useStyles = makeStyles()((theme: Theme) => ({
  startIcon: {
    '& > svg': {
      width: '1em',
      height: '1em',
    },
  },
}));

export interface IssuesControlPanelProps {
  openExportIssuesMenu: boolean;
  setOpenExportIssuesMenu: React.Dispatch<React.SetStateAction<boolean>>;
  searchValue: string;
  numberOfFilters: number;
}

export default IssuesControlPanel;
